import Vue from 'vue'
import Vuex from 'vuex'
import API from '../api'
import router from '../router'
import { ToastPlugin } from 'bootstrap-vue'
import createPersistedState from "vuex-persistedstate";



Vue.use(ToastPlugin)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),
    user: {
      first_name: null,
      last_name: null, 
      icon: null, 
      gender: null, 
      coin: 0, 
      email: null
    }, 
    page: null, 
    onboarding: null, 
    page: 
    {
      notifications: null, 
      content: null, 
      theorys: null,
    }
  },
  getters: {
    isLogged: state => {
      return state.token == null ? false : true;
    },
    userData: state => {
      return state.user
    },
    currentPage: state => {
      return state.page
    }, 
    isOnboardingComplete: state => {
      return state.onboarding
    }, 
    content: state => {
      return state.page.content
    }, 

  },
  mutations: {
    //вызываем для изменения state + используем для получения данные из state
    setLogout(state) {
      localStorage.removeItem('token')
      state.token = null
      state.user = {
        first_name: null,
        last_name: null, 
        icon: null, 
        gender: null, 
        email: null,
        coin: 0
      }, 
      state.page= null, 
      state.onboarding = null
    },

    tokenUpdate(state, token) {
      localStorage.setItem('token', token)
      state.token = token
    },
    setEmail(state, email) {
      state.user.email = email
    },

    setPage(state, data){
      state.page = data.page,
      state.onboarding = data.onboarding
    }, 
    setUser(state, data){
      state.user.first_name = data.first_name,
      state.user.last_name = data.last_name,
      state.user.icon = data.icon,
      state.user.gender = data.gender, 
      state.user.coin = data.balance?data.balance:state.user.coin,
      state.user.email = data.email
    },
    setContent(state, data){
      state.page.data = data
    }

  },
  actions: {
    user_data(context, authdata)
    {

        API.get('api/me/',
        {headers: {
          'Authorization': `Bearer ${this.state.token}`
        }}
        )
        .then(function (response) {

          context.commit('setUser', {email: response.data.email,first_name: response.data.first_name, last_name: response.data.last_name, icon:  response.data.avatar, gender:  response.data.male, balance:  response.data.balance})
        })
          
          
      
    },
    social_login(context, authdata)
    {
        this.state.token = authdata.token
        API.get('api/me/',
        {headers: {
          'Authorization': `Bearer ${this.state.token}`
        }}
        )
        .then(function (response) {

          
          context.commit('setPage', {page: response.data.current_page, onboarding: response.data.onboarding_complete})
          context.commit('setUser', {email: response.data.email,first_name: response.data.first_name, last_name: response.data.last_name, icon:  response.data.avatar, gender:  response.data.male, balance:  response.data.balance})
          router.push({ path: '/makeUser' })
        })
          
          
      
    },
    login(context, authdata) {
      const data = new FormData();
      data.append('username', authdata.username);
      data.append('password', authdata.password);
      data.append('vm',authdata.vm)
      API.post('api/token/', data)
        .then(response => {
        context.commit('tokenUpdate', response.data.token);
        const token = localStorage.getItem('token')
        if (token){
          API.get('api/me/',
          {headers: {
            'Authorization': `Bearer ${token}`
          }}, data
          )
          .then(function (response) {
            if (true){//добавить про подверждение почты, если понадобится
              
              context.commit('setPage', {page: response.data.current_page, onboarding: response.data.onboarding_complete})
              if (response.data.first_name=='' ||response.data.email=='' || response.data.email== null|| response.data.avatar== null){
                context.commit('setEmail', response.data.email);
                
                
                router.push({ path: '/makeUser' })
              } else {
                context.commit('setUser', {first_name: response.data.first_name, last_name: response.data.last_name, icon:  response.data.avatar, gender:  response.data.male, balance:  response.data.balance , email:  response.data.email})
             
                router.push({ path: '/' })
              }
            } else {
              authdata.vm.$bvToast.toast('Проверьте почту и подтвердите e-mail', {
                title: 'Ваш e-mail не подтвержден',
                variant: 'danger',
                solid: true
              })    
            }
          }        
           // router.push({ path: '/makeUser' })
          )
        }}    
        ).catch(e =>{
          authdata.vm.$bvToast.toast('Проверьте и введите еще раз ', {
            title: 'Неверный логин или пароль',
            variant: 'danger',
            solid: true
          })
        });
    },

    logout(context){
      context.commit('setLogout');
      router.push({path: '/landing'})
    },

    registration({ commit, dispatch }, authdata){
      
    },

    makeUser(context, authdata){
      
      const token = this.state.token

      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      const data = new FormData();
      data.append('first_name', authdata.first_name);
      data.append('last_name', authdata.last_name);
      data.append('email', authdata.email);
      let gender = false
      var icon = ''
      if (authdata.gender == 'Ж'){
        data.append('male', false);
        data.append('avatar', 'avatars/woman'+ authdata.icon +'.png' );
        icon = '/media/avatars/woman'+ authdata.icon +'.png'
      } else {
        gender = true
        data.append('male', true);
        data.append('avatar', 'avatars/man'+ authdata.icon +'.png' );
        icon = '/media/avatars/man'+ authdata.icon +'.png'
      }
      if (token){

      API.put('api/me/', data, config)
        .then(function (response) {

          context.commit('setUser', {email:authdata.email, first_name: authdata.first_name, last_name: authdata.last_name, icon:  icon, gender:  gender})
          router.push({ path: '/' })
        })
        .catch(e =>{

          if(e.response.status == 401)
          {
            context.commit('setLogout');
            router.push({path: '/landing'})
          }
        });
      }
    }
  },
  modules: {

  }, 
  plugins: [
    createPersistedState()
  ]
})
